import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'serviceNumber'
})
export class ServiceNumberPipe implements PipeTransform {
  transform(value: string): string {
    return value?.split('|')[1] || '1';
  }
}
